import { Icon, IconComponent } from 'ui'
import { UGELayer } from '../../../../types'

type Props = {
    className?: string
    layer: UGELayer
}

const UGELayersEditorLayerHeaderIcon = ({ className, layer }: Props) => {
    function getIcon(): Icon {
        switch (layer.type) {
            case 'text':
                return 'text'
            default:
                return 'sticker'
        }
    }

    return <IconComponent className={className} height={18} icon={getIcon()} width={18} />
}

export default UGELayersEditorLayerHeaderIcon
